import type { IIssueRepository } from '../repositories/IIssueRepository.js';

interface Deps { issueRepository: IIssueRepository; }

export function createDeleteIssueUseCase({ issueRepository }: Deps) {
  return async function deleteIssue(id: string): Promise<void> {
    return issueRepository.delete(id);
  };
}
